// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1VXnq","obliqueLineWrap":"membershipbadge_obliqueLineWrap__39_KU","obliqueLine":"membershipbadge_obliqueLine__1QOQB"};